import { IdentifyableEntity } from "@iventis/domain-model/model/identifyableEntity";
import { MapObject } from "@iventis/domain-model/model/mapObject";
import { SavedMapView } from "@iventis/domain-model/model/savedMapView";
import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { AxiosInstance } from "axios";
import { ReactNode } from "react";

export enum SearchResultType {
    SAVED_MAP_VIEW = "saved_map_view",
    LOCATION = "location",
    MAP_OBJECT = "map_objects",
    SITEMAP = "sitemap",
}

export type ResultType = IdentifyableEntity & { name?: string; thumbnailUrl?: Promise<string> };

export type MapSearchResultType = SavedMapView | MapboxLocationResult | MapObject | Sitemap;

export interface MapboxLocationResult {
    id: string;
    name: string;
    bounds: [number, number, number, number];
}

export enum SearchState {
    IDLE = "IDLE",
    SEARCHING = "SEARCHING",
    SHOWING_RESULTS = "SHOWING_RESULTS",
}

export interface ResultGroup<TResult extends ResultType> {
    name: string;
    type: SearchResultType;
    icon: ReactNode;
    onResultClick: (result: TResult, displayText?: string) => void;
    results: SearchResult<TResult>[];
}

export interface SavedMapViewOptions {
    api: AxiosInstance;
    mapId: string;
}

export interface MapboxSearchResultOptions {
    limit: number;
    types: MapboxSearchType[];
    mapboxSearchApiUrl: string;
    getMapPosition: () => [number, number];
}

export type MapboxSearchType = "country" | "region" | "postcode" | "district" | "place" | "locality" | "neighborhood" | "address" | "poi";

export interface MapObjectSearchOptions {
    api: AxiosInstance;
    getLayers: () => { id: string; thumbnailUrl: Promise<string> }[];
}

export interface SitemapSearchOptions {
    getSitemaps: () => Sitemap[];
}

export type SearchResultCallBacksType = {
    savedMapViewsSearchResultCallback: (savedMapView: SavedMapView) => void;
    mapboxSearchResultCallback: (mapboxLocation: MapboxLocationResult, displayText?: string) => void;
    mapObjectSearchResultCallback: (mapObject: MapObject, displayText?: string) => void;
    sitemapSearchResultCallback: (sitemap: Sitemap) => void;
};

export type SearchResultGetters = {
    getMapLayerPreviewUrl: (layer: MapLayer) => Promise<string>;
};
